import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
    signInWithEmailAndPassword, 
    sendPasswordResetEmail,
    signOut as firebaseSignOut,
    onAuthStateChanged
} from 'firebase/auth';
import { auth } from '../../firebase/config';

export const signIn = createAsyncThunk(
    'auth/signIn',
    async ({ email, password }) => {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        return {
            uid: userCredential.user.uid,
            email: userCredential.user.email
        };
    }
);

export const signOut = createAsyncThunk(
    'auth/signOut',
    async () => {
        await firebaseSignOut(auth);
    }
);

export const resetPassword = createAsyncThunk(
    'auth/forgotPassword',
    async (email) => {
        await sendPasswordResetEmail(auth, email);
    }
);
export const initializeAuth = createAsyncThunk(
    'auth/initialize',
    async () => {
        return new Promise((resolve) => {
            onAuthStateChanged(auth, (user) => {
                if (user) {
                    resolve({
                        uid: user.uid,
                        email: user.email
                    });
                } else {
                    resolve(null);
                }
            });
        });
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: null,
        status: 'idle',
        error: null,
        isInitialized: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(initializeAuth.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(initializeAuth.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.user = action.payload;
                state.isInitialized = true;
            })
            .addCase(signIn.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(signIn.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.user = action.payload;
            })
            .addCase(signIn.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            })
            .addCase(signOut.fulfilled, (state) => {
                state.user = null;
                state.status = 'idle';
            })
            .addCase(resetPassword.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(resetPassword.fulfilled, (state) => {
                state.status = 'succeeded';
            })
            .addCase(resetPassword.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
            });
    }
});

export default authSlice.reducer;